import { render, staticRenderFns } from "./QuoteBuilderLabourItemTemplate.vue?vue&type=template&id=4aa32b66"
import script from "./QuoteBuilderLabourItemTemplate.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderLabourItemTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderLabourItemTemplate.vue?vue&type=style&index=0&id=4aa32b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports